<template>
  <div>
    <b-card border-variant="info" header="News">
      <div
        class="d-flex flex-column mb-2"
        v-for="announcement in annArray"
        :key="announcement.id"
      >
        <div class="d-flex justify-content-between">
          <strong>{{ announcement.subject }}</strong>
          <span class="text-muted text-right">
            {{ announcementDate(announcement.announce_date) }}
          </span>
        </div>
        <span>{{ announcement.body }}</span>
      </div>
    </b-card>
  </div>
</template>
<script>
  import { getCleanDate } from '@/utils'

  export default {
    props: {
      annArray: Array
    },
    methods: {
      announcementDate(rawDate) {
        return getCleanDate(rawDate, 'DD MMM')
      }
    }
  }
</script>
